export default __webpack_public_path__ + "static/media/vintage_cotton_raglan_pullover_1_370x450_crop_center.progressive.png.2c7b7bb6.jpg";